export default __webpack_public_path__ + "static/image25-06568828554d4fc9bd9a2014d377b6aa.gif";